import { NotFound } from '@factorialco/deprecated-design-system'
import { CanUserSeeMarketplaceDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { IntegrationList } from 'modules/marketplace/components/IntegrationList'
import { IntegrationsCatalogProvider } from 'modules/marketplace/components/IntegrationList/IntegrationsCatalogProvider'

const ListIntegrationsPage = () => {
  const { data, loading } = useQuery(CanUserSeeMarketplaceDocument)
  const canSeeMarketplace = data?.marketplace._policies.marketplaceSeeMarketplace.can

  track(trackingEvents.marketplace.visitMarketplaceIntegrations)
  return (
    <IntegrationsCatalogProvider>
      <ResponsivePage.Body showHeader={false} loading={loading} error={null}>
        {canSeeMarketplace ? (
          <IntegrationList />
        ) : (
          <NotFound
            title={i18n.t('errors.page_not_found.title')}
            description={i18n.t('errors.page_not_found.description')}
          />
        )}
      </ResponsivePage.Body>
    </IntegrationsCatalogProvider>
  )
}

export default ListIntegrationsPage
